export const LOCAL_STORAGE_KEY = {
    AUTH_TOKEN: 'auth_token',
    LAYOUT_CONFIG: 'layoutConfig',
} as const;
